(function() {
    'use strict';

    angular
        .module('app')
        .factory('pageSearchService', pageSearchService);

    pageSearchService.$inject = ['$http', '$q'];

    function pageSearchService($http, $q) {
        var service = {
            getResults: getResults,
			getExternalResults: getExternalResults,
			trackClick: trackClick

    };

        return service;

        function getResults(queryString, sites, filters, contentTypes, publications) {
            var deferred = $q.defer();

            $http.get('/api/emr/search/results', { params: { queryString: queryString, sites: sites, filters: filters, contentTypes: contentTypes, publications: publications }})
                .then(function(results) {
                    deferred.resolve(results.data);
                }).catch();

            return deferred.promise;
		}

		function trackClick(t_id, t_q, t_hit_id, t_hit_pos) {

		    var deferred = $q.defer();

			$http.get('/api/emr/search/track', { params: { query: t_q, hitId: t_hit_id, trackId: t_id, hitPos: t_hit_pos } })
			    .then(function (results) {
				    deferred.resolve(results.data);
			    }).catch();

		    return deferred.promise;
	    }

        function getExternalResults(queryString) {
            var deferred = $q.defer();

            $http.get('/api/emr/search/externalResults', { params: { queryString: queryString } })
                .then(function(results) {
                    deferred.resolve(results.data);
                }).catch();

            return deferred.promise;
        }


    }
})();


//////////////////
// WEBPACK FOOTER
// ./static/common/js/factories/_pageSearchService.js
// module id = 11
// module chunks = 0